<template>
    <span>
        <pazar-plus-details></pazar-plus-details>
        <pazar-plus-modules></pazar-plus-modules>
        <page-footer></page-footer>
    </span>
</template>

<script>
import PazarPlusDetails from '@/components/PazarPlusDetails';
import PazarPlusModules from '@/components/PazarPlusModules';
import PageFooter from '@/components/PageFooter';
export default {
    name: 'pazarPlus',
    components: {
        PazarPlusDetails,
        PazarPlusModules,
        PageFooter
    },
    methods: {
        // priceList() {
        //     let productCode = 'pazarplus'
        //     this.$store.dispatch('getPriceList', productCode);
        // }
    },
    mounted: function() {
        // this.priceList();
    }
};
</script>


